import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { InViewTracking } from '../components/InViewTracking';
export function withScrollTracking(Component) {
    return (props) => {
        return (_jsx(InViewTracking, { children: _jsx(Component, Object.assign({}, props)) }));
    };
}
//# sourceMappingURL=withScrollTracking.js.map